module.exports = __webpack_public_path__ + "static/media/buildingConstruction40.db6649e8.jpg";